import React from 'react'
import {BlockComponentProps} from '../index'
import {usePurchaseForm} from './PurchaseFormProvider'
import SectionLabel from './SectionLabel'
import {Font} from '../../lib/font'
import {PurchaseFormBlockBase} from '.'
import {usePurchase} from '../../PurchaseContext'

interface CompanyNameProps extends PurchaseFormBlockBase {
  TextFieldComponent: React.FC<any>
  CompanyNameLabelComponent?: React.FC<any>
  companyNameLabel?: string
  questions: {
    sameShippingAddress: string
  }
  sectionLabel?: {
    font: Font | null
    fontSize?: number
    margin: {
      top: number
      right: number
      bottom: number
      left: number
    }
  }
}

export default function CompanyName(
  props: CompanyNameProps & BlockComponentProps,
) {
  const {
    TextFieldComponent,
    CompanyNameLabelComponent = (props: {companyNameLabel?: string}) => (
      <SectionLabel {...props}>
        {props.companyNameLabel ?? 'Company'}
      </SectionLabel>
    ),
    ...config
  } = props

  const {selectedTicket} = usePurchase()

  const {
    companyNameError,
    isExistingAttendee,
    setCompanyName,
    companyName,
    setCompanyNameError,
  } = usePurchaseForm()

  const onChangeCompanyName = (e: any) => {
    validateCompanyName(e)
    setCompanyName(e)
  }
  const isEmpty = (value: string) => value.trim().length === 0

  const validateCompanyName = (value: string) => {
    if (selectedTicket?.company_name_required && isEmpty(value)) {
      setCompanyNameError('Company name is required')
      return false
    }
    setCompanyNameError(null)
    return true
  }

  return (
    <div>
      <CompanyNameLabelComponent
        companyNameLabel={props.companyNameLabel}
        {...props}
      />
      <TextFieldComponent
        aria-label={`company name`}
        config={config}
        placeholder={'companyName'}
        value={companyName}
        onChange={onChangeCompanyName}
        error={!!companyNameError}
        disabled={isExistingAttendee}
      />
    </div>
  )
}
